import React from "react";

import { Provider } from "jotai";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import qs from "query-string";

import { API } from "@aws-amplify/api";
import App from "./App";
import awsmobile from "./aws-exports";

API.configure(awsmobile);

const { customer_id } = qs.parse(location.search) ?? {};
const customerId = customer_id ? customer_id.toString() : undefined;

console.log("Configuration =>", awsmobile);
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider>
      <BrowserRouter>
        <div className={`gpc-app ${__BRAND__ ? __BRAND__ : ""}`}>
          <App customerId={customerId} />
        </div>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
